import { createApp } from 'vue'
import store from 'store'

import CheckoutLine from './CheckoutLine.vue'

const el = '.nti-component--checkout-line'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(CheckoutLine)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}